import { Box, Typography } from '@mui/material';

const FieldDisplay = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="body2">
      {value !== undefined && value !== null && value !== '' ? String(value) : '-'}
    </Typography>
  </Box>
);

export default FieldDisplay;
